var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRollRibbon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M23.7 15.7c2.6 0 4.6-1.1 4.6-2.6s-2-2.6-4.5-2.6c-2.6 0-4.5 1.1-4.5 2.6s1.8 2.6 4.4 2.6zm0-3.7c1.9 0 3 .7 3 1.1s-1.2 1.1-3 1.1-3-.7-3-1.1c-.1-.4 1.1-1.1 3-1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M23.7 5.1C15.1 5.1 8.4 8.6 8.4 13v6.4l.1 7.6c0 2.5 3.7 7.7 15.3 7.7C35.4 34.7 39 29.5 39 27V13c0-4.4-6.7-7.9-15.3-7.9zm0 14.4c-7.5 0-13.8-3-13.8-6.4 0-3.5 6.3-6.4 13.8-6.4s13.8 3 13.8 6.4c0 3.5-6.3 6.4-13.8 6.4z"
  })));
};
export default SvgIconRollRibbon;